import { createContext } from 'react';

export const context = createContext<{
  offsetTop: string;
  options: Array<string>;
  setOptionVisibility: (id: string, isVisible: boolean) => void;
  activeOption?: string;
}>(undefined as any);
